module.exports = __webpack_public_path__ + "img/TUR.f8019bad.png";